import { GoalImpactLevel } from '@griply/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { usePopupMenuArrowNavigation } from 'shared/hooks/use-popup-menu-arrow-navigation';

export type ImpactPickerMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'children' | 'onOutside'
> & {
  value?: GoalImpactLevel | null;
  onClose: () => void;
  onChange: (value: GoalImpactLevel | null) => void;
};

export const ImpactPickerMenu: React.FC<ImpactPickerMenuProps> = ({
  value,
  onChange,
  onClose,
  ...rest
}) => {
  const { t } = useTranslation();
  const menuRef = React.useRef<HTMLDivElement>(null);

  const onHigh = () => {
    onChange(GoalImpactLevel.High);
    onClose();
  };

  const onMedium = () => {
    onChange(GoalImpactLevel.Medium);
    onClose();
  };

  const onLow = () => {
    onChange(GoalImpactLevel.Low);
    onClose();
  };

  const onNone = () => {
    onChange(null);
    onClose();
  };

  usePopupMenuArrowNavigation({ containerRef: menuRef });

  return (
    <PopupMenu ref={menuRef} onOutside={onClose} {...rest}>
      <PopupMenuList>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onHigh}
            start={
              value === GoalImpactLevel.High ? <Icon icon={Check} /> : undefined
            }
            indentationLevel={value !== GoalImpactLevel.High ? 1 : 0}
          >
            {t('goal.impact.options.high.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onMedium}
            start={
              value === GoalImpactLevel.Medium ? (
                <Icon icon={Check} />
              ) : undefined
            }
            indentationLevel={value !== GoalImpactLevel.Medium ? 1 : 0}
          >
            {t('goal.impact.options.medium.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onLow}
            start={
              value === GoalImpactLevel.Low ? <Icon icon={Check} /> : undefined
            }
            indentationLevel={value !== GoalImpactLevel.Low ? 1 : 0}
          >
            {t('goal.impact.options.low.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onNone}
            start={value === null ? <Icon icon={Check} /> : undefined}
            indentationLevel={value !== null ? 1 : 0}
          >
            {t('goal.impact.options.none.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
      </PopupMenuList>
    </PopupMenu>
  );
};
